import { useState } from "react";
import { Modal } from "src/Components";
import { Header, ITableReport, Report } from "src/Interfaces/TableInterfaces";
import { getCCOrderImbalanceChecksTable } from "src/Requests/ccOrder";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";

export interface CCChanceFilter { id?: number; ids?: number[]; conditionId?: number }
interface ImbalanceRow extends ITableReport { [key: string]: unknown }

const ImbalanceChecksTableUI = ({ reports }: { reports: Report<ImbalanceRow> }) => {
  const headers = reports.translatedHeaders;
  const fixed = headers.filter(header => !header.groupName);
  const groups = Array.from(new Set(headers.map(header => header.groupName).filter(Boolean)));
  const cell = (row: ImbalanceRow, header: Header) => {
    const key = header.headerName.charAt(0).toLowerCase() + header.headerName.slice(1);
    const value = row[key];
    return <span dir="ltr" className="inline-block whitespace-nowrap tabular-nums">
      {value == null ? "—" : typeof value === "number"
        ? value.toLocaleString("en-US", { maximumSignificantDigits: 12 }) : String(value)}
    </span>;
  };
  const heading = (header: Header, rowSpan = 1) => {
    const sideLabels = header.translateHeaderName.match(/^(.*?)\((اول|دوم) \/ (اول|دوم)\)$/);
    return <th key={header.headerName} rowSpan={rowSpan}
      scope="col" title={header.headerSubtitle} className="border border-slate-200 px-3 py-3 font-bold">
      {sideLabels ? <>{sideLabels[1]}<bdi dir="ltr" className="inline-flex whitespace-nowrap">(<bdi dir="rtl">{sideLabels[2]}</bdi><span className="whitespace-pre"> / </span><bdi dir="rtl">{sideLabels[3]}</bdi>)</bdi></>
        : header.translateHeaderName}
    </th>;
  };
  return <div className="max-h-[65vh] w-full overflow-auto rounded border border-slate-200">
    <table aria-label="گزارش بررسی ناترازی شانس‌ها" className="w-full min-w-max border-separate border-spacing-0 text-center text-xs">
      <thead className="sticky top-0 z-10 bg-slate-100">
        <tr>
          {fixed.map(header => heading(header, groups.length ? 2 : 1))}
          {groups.map(group => <th key={group} scope="colgroup"
            colSpan={headers.filter(header => header.groupName === group).length}
            className="border border-slate-200 px-3 py-3 font-bold">{group}</th>)}
        </tr>
        {groups.length ? <tr>{headers.filter(header => header.groupName).map(header => heading(header))}</tr> : null}
      </thead>
      <tbody>
        {reports.report.map(row => <tr key={row.id} className="even:bg-slate-50 hover:bg-sky-50">
          {headers.map(header => <td key={header.headerName} className="border border-slate-200 px-3 py-3">{cell(row, header)}</td>)}
        </tr>)}
        {!reports.report.length ? <tr><td colSpan={headers.length} className="p-6 text-slate-500">شانسی برای نمایش وجود ندارد.</td></tr> : null}
      </tbody>
    </table>
  </div>;
};

const ImbalanceChecksButton = ({ searchParam }: { searchParam: CCChanceFilter }) => {
  const [open, setOpen] = useState(false);
  return <>
    <button type="button" onClick={() => setOpen(true)}
      className="rounded bg-sky-700 px-4 py-2 text-xs text-white hover:bg-sky-800">بررسی ناترازی</button>
    {open ? <Modal title="بررسی ناترازی شانس‌ها" onClose={() => setOpen(false)}
      modalBoxClassName="!w-[95vw] !min-w-0"
      UI={<div dir="rtl" className="w-full min-w-0 space-y-3">
        <h2 className="text-sm font-bold">بررسی ناترازی شانس‌ها</h2>
        <p className="text-xs leading-6 text-gray-500">
          حجم هر سمت در واحد همان لگ و ترتیب سمت‌ها مطابق سفارش است.
          حجم لغو و ارسال جدید، به معنی پذیرش یا انجام سفارش نیست. «—» یعنی این مرحله اجرا نشده یا جزئیات آن در سوابق ثبت نشده است.
        </p>
        <TableTemplate<CCChanceFilter, ImbalanceRow>
          showIsLoading refreshTableTime={5000}
          tableWrapperClassname="!mx-0 !min-w-0 !w-full !max-w-full"
          getDataTable={(_, offset, pageSize) => getCCOrderImbalanceChecksTable(searchParam, offset, pageSize)}
          TableUI={ImbalanceChecksTableUI}
        />
      </div>} /> : null}
  </>;
};

export default ImbalanceChecksButton;
